import angular from 'angular';

angular
  .module('depositor', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('depositor', {
          data: {
            authorizedRole: 'USER_BO'
          }
        })
        .state('depositor_details', {
          url: '/depositor/{tabName}/{depositorId:[0-9]+}',
          templateUrl: require('./depositor-details.html'),
          controller: 'DepositorDetailsCtrl',
          resolve: {
            depositor: [
              '$transition$',
              'DepositorService',
              function($transition$, DepositorService) {
                return DepositorService.get({ depositorId: $transition$.params().depositorId });
              }
            ]
          },
          data: {
            authorizedRole: 'CONFIGURATOR'
          }
        });
    }
  ]);
